import { useState, useEffect } from 'react'
import Archives from './Components/Archives'
import OldArchives from './Components/OldArchives'
import { $api } from '../../../../../helpers/api'

const ArchivedList = () => {
  const [archives, setArchives] = useState([])

  useEffect(() => {
    const request = async () => {
      const res = await $api.get('/archive')
      setArchives(res.data)
    }
    request()

    return () => {
      setArchives([])
    }
  }, [])

  return (
    <>
      <div className='archived-files'>
        <Archives archives={archives} />
        <OldArchives archives={archives} />
      </div>
    </>
  )
}

export default ArchivedList
